import { Component, OnInit } from '@angular/core';
import { ViewChild, Inject } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { UsersAndGroupsService } from 'src/app/_services/users-and-groups.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { DialogViewGroupsComponent } from '../dialog-view-groups/dialog-view-groups.component';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {

  hide: boolean = true;
  isDisplayPage: boolean = true;
  isCreateUser: boolean = false;
  isUserCreated: boolean = false;
  createUserResponse: any
  isViewGroup: boolean = false;
  fetchedGroups: any;
  allUsers: any;
  userSelected: any;
  isUserNull: boolean = false
  userForm: FormGroup
  displayedColumns = ["username", "email", "phonenumber", "actions"];
  displayedGroupsColumns: any[] = ['group']
  usersCount: number = 0

  constructor(
    public dialog: MatDialog,
    private fb: FormBuilder,
    private usersAndGroupsService: UsersAndGroupsService
  ) {
    this.createUserForm()
  }
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  ngOnInit() {
    this.isDisplayPage = true

    this.usersAndGroupsService.getAllUsers().subscribe(users => {
      this.allUsers = users.Users;
      this.allUsers = new MatTableDataSource(users.Users);
      this.allUsers.sort = this.sort;
      this.allUsers.paginator = this.paginator;
      this.usersCount = this.allUsers.data.length
    })
  }

  createUserForm() {
    this.userForm = this.fb.group({
      username: ['', Validators.required],
      email: ['', Validators.required],
      password: ['', Validators.required],
      //confirmPassword: ['', Validators.required],
      firstname: ['', Validators.required],
      lastname: ['', Validators.required]
    })
  }

  viewUserGroups(event, user) {
    this.isViewGroup = true
    var getGroupsPayload = {
      "user": user.Username
    }
    this.userSelected = user.Username
    this.usersAndGroupsService.getGroupsForUser(getGroupsPayload).subscribe(users => {
      this.fetchedGroups = users
      if (this.fetchedGroups.length === 0) {
        this.isUserNull = true
      }
    })
  }

  openViewGroupsDialog(user) {
    let dialogRef = this.dialog.open(DialogViewGroupsComponent,
      { width: '600px', data: user });
    dialogRef.afterClosed().subscribe(result => { });
  }

  displayPage() {
    this.isDisplayPage = true;
    this.isCreateUser = false;
    this.isViewGroup = false;
    this.isUserCreated = false;
  }

  createUser() {
    this.isDisplayPage = false
    this.isCreateUser = true;
  }

  saveUser() {
    const createUserRequest = this.userForm.value
    this.usersAndGroupsService.createUser(createUserRequest).subscribe(resp => {
      this.createUserResponse = resp
      this.isUserCreated = true
    })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.allUsers.filter = filterValue.trim().toLowerCase();
    if (this.allUsers.paginator) {
      this.allUsers.paginator.firstPage();
      this.usersCount = this.allUsers.data.length
    }
  }
}
